// import CryptoJS from "crypto-js"

import { Container, FullRow, NormalText, Title } from "../components"



export function E404(): JSX.Element {
  
  return (
    <Container>
      <FullRow>
        <Title>Opps!</Title>
      </FullRow>
      <FullRow>
        <NormalText> The page you are requesting cannot be found.</NormalText>
      </FullRow>
      
    </Container>
  )
}
